import script from "./UpdateManualAppraisalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateManualAppraisalPage.vue?vue&type=script&setup=true&lang=js"

import "./UpdateManualAppraisalPage.vue?vue&type=style&index=0&id=bd5501b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd5501b4"]])

export default __exports__